export default __webpack_public_path__ + "11a36ccd2e8c51908b3c64c01cb87642.gif";